<script lang="ts">
	import { toast } from 'svelte-sonner';
	import RoundLogout from 'virtual:icons/ic/round-logout';

	async function logout() {
		try {
			const request = await fetch('/api/logout', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				}
			});

			if (request.ok) {
				location.href = '/';
			} else {
				toast.error('Oops, terjadi kesalahan');
			}
		} catch (error) {
			console.error(error);
			toast.error('Oops, terjadi kesalahan');
		}
	}
</script>

<button on:click={logout} type="button" class="btn btn-error btn-block mt-3 text-base-100">
	Keluar / Logout
	<RoundLogout class="text-lg" />
</button>
